import {Component, ElementRef, OnDestroy, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import {ModalController, NavParams, Platform} from '@ionic/angular';
import {Subscription} from 'rxjs';
import {ScreenOrientation} from '@ionic-native/screen-orientation/ngx';
import {HelperService} from "../../service/helper.service";
import {ApiService} from "../../service/api.service";
import {TranslateConfigService} from "../../service/translate-config.service";

@Component({
  selector: 'app-tkp-xd',
  templateUrl: './tkp.component.html',
  styleUrls: ['./tkp.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class TkpXocDiaComponent implements OnInit, OnDestroy {
  @ViewChild('tkpXD', {static: false}) elTkpXD: ElementRef;
  issue: number;
  issueStoreLatest: number;
  dateIssue = '';
  diceFirst = -1;
  diceSecond = -1;
  diceThird = -1;
  diceFourth = -1;
  txtResult = '';
  getHisChan = [];
  getHisLe = [];
  listHisPageChan = [];
  totalBetChan = 0;
  totalRefundChan = 0;
  listHisPageLe = [];
  totalBetLe = 0;
  totalRefundLe = 0;
  numPageChan = 1;
  numPageLe = 1;
  isResultChan = false;
  isResultLe = false;
  subscriptionIsNextTKP: Subscription;
  subscriptionScreenOri: Subscription;
  isNextPhien = false;
  isLandscape = false;

  constructor(
    private modalCtr: ModalController,
    private navParams: NavParams,
    private hpService: HelperService,
    private apiService: ApiService,
    private screenOrientation: ScreenOrientation,
    public platform: Platform,
    private translateConfigService: TranslateConfigService
  ) {
    this.listTKPhien(navParams.data.dataTKP);
    this.issue = this.issueStoreLatest = navParams.data.txID;
    this.subscriptionIsNextTKP = this.hpService.getObserverIsValidNextTKPTXCB().subscribe(data => {
      if (data === 'checkNextTKPhien') {
        this.isNextPhien = true;
      } else if (data.hasOwnProperty('flag') && data['flag'] === 'reloadTkP') {
        this.issue = this.issueStoreLatest = data['issueNew'];
        this.getDataTKPhien();
      }
    });
    platform.ready().then((readySource) => {
      this.detectScreenOrient();
    });
    this.subscriptionScreenOri = screenOrientation.onChange().subscribe(
      () => {
        this.detectScreenOrient();
      }
    );
  }

  detectScreenOrient() {
    setTimeout(() => {
      const pH = this.platform.height();
      const pW = this.platform.width();
      let hGame = 0;
      if (pW > pH) {
        this.isLandscape = true;
        hGame = 305;
      } else if (pW < pH) {
        this.isLandscape = false;
        hGame = 490;
      }

      if (pH < hGame) {
        this.elTkpXD.nativeElement.style.transform = `scale(${(pH / hGame)})`;
      } else {
        this.elTkpXD.nativeElement.style.transform = `scale(1)`;
      }
    }, 100);
  }

  ngOnInit() {
  }

  ngOnDestroy(): void {
    this.subscriptionIsNextTKP.unsubscribe();
    this.subscriptionScreenOri.unsubscribe();
  }

  listTKPhien(dataObjHis) {
    let dataHis = dataObjHis['lstData'];
    // tslint:disable-next-line:no-eval
    const getResult = eval(dataObjHis['result']);
    this.diceFirst = getResult[0];
    this.diceSecond = getResult[1];
    this.diceThird = getResult[2];
    this.diceFourth = getResult[3];
    let totalResult = this.diceFirst + this.diceSecond + this.diceThird + this.diceFourth;

    if (totalResult == 4 || totalResult == 0) {
      this.txtResult = this.translateConfigService.getTranslateService().instant('MINI-GAME.chan');
      this.isResultChan = true;
      this.isResultLe = false;
    } else if (totalResult == 3 || totalResult == 1) {
      this.txtResult = this.translateConfigService.getTranslateService().instant('MINI-GAME.le');
      this.isResultChan = false;
      this.isResultLe = true;
    }else{
      this.txtResult = this.translateConfigService.getTranslateService().instant('MINI-GAME.hoa');
      this.isResultChan = true;
      this.isResultLe = true;
    }

    if (dataHis.length <= 0) {
      this.hpService.observableAlertMiniGame.next({msg: this.translateConfigService.getTranslateService().instant('MINI-GAME.msg-no-data')});
      this.listHisPageChan = [];
      this.listHisPageLe = [];
      this.totalBetChan = 0;
      this.totalRefundChan = 0;
      this.totalBetLe = 0;
      this.totalRefundLe = 0;
      return;
    }
    this.numPageChan = this.numPageLe = 1;
    dataHis = dataHis.map(item => {
      // tslint:disable-next-line:no-eval
      item['result'] = eval(item['result']);
      item['betamountC'] = this.hpService.convertMoneyTxt(item['betamount']);
      item['refundamountC'] = this.hpService.convertMoneyTxt(item['refundamount']);
      const betTimeItem = new Date(item['bettime']);
      item['time'] = this.hpService.getDateTimeHH_MM_SS(betTimeItem);
      return item;
    });
    const betTime = new Date(dataHis[0]['bettime']);
    this.dateIssue = this.hpService.getDateTimeByFormat(betTime, 'DD/MM/YYYY');

    this.getHisChan = dataHis.filter(item => item['typed'] === 1);
    this.totalBetChan = this.getHisChan.reduce((prevVal, {betamount}) => prevVal + betamount, 0);
    this.totalRefundChan = this.getHisChan.reduce((prevVal, {refundamount}) => prevVal + refundamount, 0);
    this.listHisPageChan = this.getHisChan.slice(0, 5);

    this.getHisLe = dataHis.filter(item => item['typed'] === 2);
    this.totalBetLe = this.getHisLe.reduce((prevVal, {betamount}) => prevVal + betamount, 0);
    this.totalRefundLe = this.getHisLe.reduce((prevVal, {refundamount}) => prevVal + refundamount, 0);
    this.listHisPageLe = this.getHisLe.slice(0, 5);
  }

  async closeModal() {
    await this.modalCtr.dismiss();
  }

  prevListTai() {
    if (this.numPageChan <= 1) {
      return;
    }
    this.numPageChan -= 1;
    this.listHisPageChan = this.getHisChan.slice((this.numPageChan - 1) * 5, this.numPageChan * 5);
  }

  nextListTai() {
    const getPagi = Math.ceil(this.getHisChan.length / 5);
    if (this.numPageChan >= getPagi) {
      return;
    }
    this.listHisPageChan = this.getHisChan.slice(this.numPageChan * 5, 5 * (this.numPageChan + 1));
    this.numPageChan += 1;
  }

  prevListXiu() {
    if (this.numPageLe <= 1) {
      return;
    }
    this.numPageLe -= 1;
    this.listHisPageLe = this.getHisLe.slice((this.numPageLe - 1) * 5, this.numPageLe * 5);
  }

  nextListXiu() {
    const getPagi = Math.ceil(this.getHisLe.length / 5);
    if (this.numPageLe >= getPagi) {
      return;
    }
    this.listHisPageLe = this.getHisLe.slice(this.numPageLe * 5, 5 * (this.numPageLe + 1));
    this.numPageLe += 1;
  }

  nextIssue() {
    if (this.isNextPhien && this.issueStoreLatest === this.issue) {
      this.hpService.observableAlertMiniGame.next({msg: this.translateConfigService.getTranslateService().instant('MINI-GAME.msg-turn-not-over')});
    } else {
      this.issue += 1;
      this.getDataTKPhien();
    }
  }

  prevIssue() {
    this.issue -= 1;
    this.getDataTKPhien();
  }

  getDataTKPhien() {

    this.hpService.observableLoading.next(true);
    this.apiService.thongKePhienXD(this.issue).subscribe(
      data => {
        this.hpService.observableLoading.next(false);
        this.listTKPhien(data);
      },
      error => {
        console.log(error);
      },
      () => {
      }
    );
  }
}
